'use strict';

import gsap from "gsap";

class BlockModalPopup {

	constructor($target) {
		
		let closeButton = $target.find(".block_modal_popup__close-btn")[0];
		
		closeButton.onclick =() => {
			$target.parent().remove();
		}
		
	}

}

export default BlockModalPopup;